define(["utils/findElements", "utils/injectJavascript", "utils/injectCSS"],
	function(findElements, injectJavascript, injectCSS) {    
               
        var addContent = function(target, htmlContent, location){
            var div = document.createElement('div');
            div.innerHTML = htmlContent;
            var elements = Array.prototype.slice.call(div.childNodes);
            switch(location){
                case "before":
                    elements.forEach(function(element){
                        target.parentNode.insertBefore(element, target);
                    });                    
                break;
                case "after":
                    elements.forEach(function(element){
                        target.parentNode.insertBefore(element, target.nextSibling);
                    });                     
                break;
                case "replace":
                    elements.forEach(function(element){
                        target.parentNode.insertBefore(element, target);
                    }); 
                    target.parentNode.removeChild(target);                    
                break;
                case "set-content":
                    target.innerHTML = '';
                    elements.forEach(function(element){
                        target.appendChild(element);
                    });
                break;
                case "append":
                    elements.forEach(function(element){
                        target.appendChild(element);
                    });
                break;  
                case "prepend":
                    elements.forEach(function(element){
                        target.insertBefore(element, target.childNodes[0]);
                    });
                break;              
                default:
                    throw new Error("Not supported location type")
            }
        }
          
        var changePageContent = function(options, callback){
            var htmlContent = options.content,
                location = options.location || "append",
                selectors = options.selectors,
                css = options.css,
                javascript = options.javascript;
            if(htmlContent){                
                if(!selectors || selectors.length == 0){
                    callback(new Error("selectors are required"));
                    return;
                }
                var elements = [];
                for(var i = 0;i < selectors.length;i++){
                    var searchResults = findElements(selectors[i]);
                    elements = elements.concat(searchResults);
                }
                if(elements.length == 0){
                    callback(new Error("No elements corresponding to selectors found"));
                    return;
                }
                elements.forEach(function(element){
                    addContent(element, htmlContent, location)
                });
            }
            if(javascript){
                injectJavascript(javascript);
            }
            if(css){
                injectCSS(css);
            }
            callback(null);
        };
		return changePageContent;
	}
);



//////////////////
// WEBPACK FOOTER
// ./responses/tags/changePageContent/changePageContent.js
// module id = 8
// module chunks = 0